import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LabWorkOrderData } from '../../../@core/interfaces/lab/lab-work-order';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { ServiceCategoryData } from '../../../@core/interfaces/masters/servicecategory';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DepartmentData } from '../../../@core/interfaces/masters/department';
import { PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import * as period from '.././../../data/period.json';

@Component({
  selector: 'ngx-pacs-queue',
  templateUrl: './pacs-queue.component.html',
  styleUrls: ['./pacs-queue.component.scss']
})

export class PacsQueueComponent implements OnInit, OnDestroy {
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  protected readonly unsubscribe$ = new Subject<void>();

  //date
  period: string = 'Today';
  fromDate: Date;
  toDate: Date;
  betweenflag: boolean = false;
  periodList: string[] = (period as any).default;
  private pacsApiUrl = environment.pacsUrl;
  private getFlaskHeaders(): { headers: HttpHeaders } {
    let token = '';
    try {
      const authStr = localStorage.getItem('auth_app_token');
      if (authStr) {
        const authData = JSON.parse(authStr);
        if (authData && authData.value) {
          // Sometimes it's a nested JSON string, sometimes an object, sometimes just the token string
          if (typeof authData.value === 'string' && authData.value.startsWith('{')) {
            token = JSON.parse(authData.value).access_token || '';
          } else if (typeof authData.value === 'object') {
            token = authData.value.access_token || '';
          } else {
            token = authData.value;
          }
        }
      }
    } catch (e) {
      console.error('Error parsing token for Flask:', e);
    }

    // Debug log to confirm if token was found before sending the request
    console.log("PACS View Flask Token check:", token ? `Found token starting with: ${token.substring(0, 15)}...` : "TOKEN NOT FOUND!");

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
  }

  // Lab orders data
  labOrders: any[] = [];
  filteredOrders: any[] = [];
  dupFilteredOrders: any[] = [];
  originalApiData: any[] = []; // Store original API response
  loading: boolean = false;
  subCategoryData: any[] = [];
  selectedSubCategory: string = 'ALL'; // Default to CT

  // Store subcategory ID mapping
  subCategoryMap: Map<string, string> = new Map();

  // Modality dropdown options
  modalityOptions = [
    { id: 'ALL', name: 'ALL' }, 
    { id: 'CT', name: 'CT' },
    { id: 'MRI SCAN', name: 'MRI SCAN' },
    { id: 'XRAY', name: 'XRAY' },
    { id: 'MEDISCAN', name: 'MEDISCAN' },
    { id: 'RADIOLOGY', name: 'RADIOLOGY' },
    { id: 'USG', name: 'USG' },
    { id: 'MAMMOGRAPHY', name: 'MAMMOGRAPHY' },
    { id: 'MAMOGRAM', name: 'MAMOGRAM' },
    { id: 'SONOGRAPHY', name: 'SONOGRAPHY' },
    { id: 'ECHO', name: 'ECHO' },
    { id: 'ECG', name: 'ECG' },
    { id: 'FLUOROSCOPY', name: 'FLUOROSCOPY' },
    { id: 'ENDOSCOPY', name: 'ENDOSCOPY' }
  ];

  // Search form
  searchForm: FormGroup;

  // For table display
  currentPage: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;

  // For order details
  orderDetails: Map<number, any> = new Map();

  // For BlueLight viewer
  showViewer: boolean = false;
  viewerUrl: SafeResourceUrl;

  constructor(
    private fb: FormBuilder,
    private labWorkOrderService: LabWorkOrderData,
    private dateService: DateService,
    private srvCatgrySrvc: ServiceCategoryData,
    private sanitizer: DomSanitizer,
    private http: HttpClient, // Add HttpClient,
    protected deptSrvc: DepartmentData,
    protected phySrvc: PhysicianData
  ) {
    this.searchForm = this.fb.group({
      patientID: [''],
      patientName: [''],
      mobileNumber: [''],  // Add mobile number
      serviceName: [''],
      department: [''],
      studyDate: [''],
      physician: [''],
      limit: [10],
      offset: [0]
    });
  }

  ngOnInit(): void {
    this.fetchSubCategories();
    this.loadDepartment();
    this.getAllPhysicians();
  }

  fetchSubCategories(): void {
    // For subcategories, still use the original service since it works
    this.srvCatgrySrvc.listsubcategory(
      `${this.tenantId}/${this.branchId}/labworkordermst/radOrderAccessDet/${this.userId}`
    )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {

        if (data && data.length > 0) {
          this.subCategoryData = data.map(x => ({
            id: x.subcategory.id,
            name: x.subcategory.name
          }));

          // Create mapping for quick lookup
          this.subCategoryData.forEach(item => {
            this.subCategoryMap.set(item.name.toUpperCase(), item.id);
          });

          // Load default orders after getting subcategories
          this.loadDefaultOrders();
        } else {
          this.subCategoryData = [];
        }
      }, error => {
      });
  }

  loadDefaultOrders(): void {
    this.loading = true;

    // Get the subcategory ID for the selected modality
    const selectedModality = this.subCategoryData.find(x =>
      x.name.toUpperCase() === this.selectedSubCategory.toUpperCase()
    );

    // Get ALL subcategory IDs if "All" is selected, otherwise get selected one
    let subcategyid = [];

    if (this.selectedSubCategory === 'ALL') {
      // Get all subcategory IDs like the Radiology component does
      subcategyid = this.subCategoryData.map(x => x.id);
    } else if (selectedModality) {
      subcategyid = [selectedModality.id];
    } else if (this.subCategoryData.length > 0) {
      // Default to first subcategory
      subcategyid = [this.subCategoryData[0].id];
    }
     var date = this.dateService.currentDate();
    if (this.period != "" && this.period != "Between") {
      switch (this.period) {
        case 'Today':
          this.rangeDate = null;
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
          this.toDate = date;
          break;
        case 'This Month':
          this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this.toDate = date;
          break;
        case 'This Year':
          this.fromDate = new Date(date.getFullYear(), 0, 1);
          this.toDate = date;
          break;
        case 'All':
          this.fromDate = null;
          this.toDate = date;
          break;
        default:
          break;
      }
    }
    else {
      if (this.rangeDate !== null && this.rangeDate !== undefined) {
        if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate = date;
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
          this.fromDate = null;
          this.toDate = this.rangeDate[1];
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] != null && this.rangeDate[0] != undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate = this.rangeDate[1];
        }
      }
    }
    const payload = {
      SSCIds: subcategyid,
      fromDate: this.dateService.utcFromDate(this.fromDate),
      toDate: this.dateService.utcToDate(this.toDate),
      pageName: "waiting"  // Same as Radiology's Waiting List tab
    };

    // Call the Flask server
    const url = `${this.pacsApiUrl}/${this.tenantId}/${this.branchId}/labworkordermst/getOrderDetForGivenModality`;

    this.http.post(url, payload, this.getFlaskHeaders())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response: any) => {

          this.handleApiResponse(response);
        },
        (error) => {
          this.loading = false;
          this.labOrders = [];
          this.filteredOrders = [];
          this.dupFilteredOrders = [];

          this.totalRecords = 0;
        }
      );
  }
  fdateflag: boolean = false;
  tdateflag: boolean = false;
  rangeDate: Date[];
  searchOrders(): void {
    this.loading = true;

    const formValues = this.searchForm.value;

    // Get subcategory IDs based on selected modality
    let sscIds = [];

    if (this.selectedSubCategory === 'ALL') {
      sscIds = this.subCategoryData.map(x => x.id);
    } else {
      const subCategoryId = this.subCategoryMap.get(this.selectedSubCategory.toUpperCase());
      if (subCategoryId) {
        sscIds = [subCategoryId];
      }
    }
    var date = this.dateService.currentDate();
    if (this.period != "" && this.period != "Between") {
      switch (this.period) {
        case 'Today':
          this.rangeDate = null;
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
          this.toDate = date;
          break;
        case 'This Month':
          this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this.toDate = date;
          break;
        case 'This Year':
          this.fromDate = new Date(date.getFullYear(), 0, 1);
          this.toDate = date;
          break;
        case 'All':
          this.fromDate = null;
          this.toDate = date;
          break;
        default:
          break;
      }
    }
    else {
      if (this.rangeDate !== null && this.rangeDate !== undefined) {
        if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate = date;
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
          this.fromDate = null;
          this.toDate = this.rangeDate[1];
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] != null && this.rangeDate[0] != undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate = this.rangeDate[1];
        }
      }
    }

    // const fromDate = this.dateService.utcFromDate(new Date());
    // const toDate = this.dateService.utcToDate(new Date());

    // Build search payload
    const searchPayload: any = {
      SSCIds: sscIds,
      fromDate: this.dateService.utcFromDate(this.fromDate),
      toDate: this.dateService.utcToDate(this.toDate),
      pageName: "waiting",
      limit: formValues.limit || 10,
      offset: formValues.offset || 0,
      // physician:formValues.physician || null,
      // department:formValues.department || null
    };

    // Add search parameters
    if (formValues.patientID && formValues.patientID.trim()) {
      searchPayload.patientID = formValues.patientID.trim();
    }

    if (formValues.patientName && formValues.patientName.trim()) {
      searchPayload.patientName = formValues.patientName.trim();
    }

    if (formValues.mobileNumber && formValues.mobileNumber.trim()) {  // Add mobile number search
      searchPayload.mobileNumber = formValues.mobileNumber.trim();
    }

    if (formValues.serviceName && formValues.serviceName.trim()) {
      searchPayload.serviceSubCategories = formValues.serviceName.trim();
    }

    if (formValues.department && formValues.department.trim()) {
      searchPayload.department = formValues.department.trim();
    }

    if (formValues.studyDate && formValues.studyDate.trim()) {  // Add study date search
      searchPayload.studyDate = formValues.studyDate.trim();
    }

    if (formValues.physician && formValues.physician.trim()) {
      searchPayload.doctorName = formValues.physician.trim();
    }


    // Use the searchOrders endpoint in Flask
    const url = `${this.pacsApiUrl}/${this.tenantId}/${this.branchId}/labworkordermst/searchOrders`;

    this.http.post(url, searchPayload, this.getFlaskHeaders())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response: any) => {

          if (response.error) {
            this.loading = false;
            this.filteredOrders = [];
            this.dupFilteredOrders = [];
            this.totalRecords = 0;
            return;
          }

          this.handleApiResponse(response, true);
        },
        (error) => {
          this.loading = false;
          this.filteredOrders = [];
          this.dupFilteredOrders = [];
          this.totalRecords = 0;
        }
      );

    if (this.betweenflag == true && this.fromDate == null && this.toDate == null) {
      this.fdateflag = true
      this.tdateflag = true
    }
    else if (this.betweenflag == true && this.fromDate == null && this.toDate != null) {
      this.fdateflag = true
    }
    else if (this.betweenflag == true && this.fromDate != null && this.toDate == null) {
      this.tdateflag = true
    }
  }

  // Add fallback search method
  private fallbackSearch(formValues: any): void {
    // First load default orders
    this.loadDefaultOrders();

    // Then filter them client-side
    setTimeout(() => {
      if (this.labOrders.length > 0) {
        let filtered = [...this.labOrders];

        // Apply filters
        if (formValues.patientID && formValues.patientID.trim()) {
          filtered = filtered.filter(order => {
            const patientId = order['Patient ID'] || order.patientID || order.regNum || '';
            return patientId.toString().toLowerCase().includes(formValues.patientID.toLowerCase().trim());
          });
        }

        if (formValues.patientName && formValues.patientName.trim()) {
          filtered = filtered.filter(order => {
            const patientName = order['Patient\'s Name'] || order.patientName || order.name || '';
            return patientName.toString().toLowerCase().includes(formValues.patientName.toLowerCase().trim());
          });
        }

        if (formValues.mobileNumber && formValues.mobileNumber.trim()) {
          filtered = filtered.filter(order => {
            const mobile = order.Mobile || order.mobile || '';
            return mobile.toString().includes(formValues.mobileNumber.trim());
          });
        }

        if (formValues.serviceName && formValues.serviceName.trim()) {
          filtered = filtered.filter(order => {
            const services = order.ServiceSubCategories || order.serviceSubCategories || [];
            if (Array.isArray(services)) {
              return services.some((service: string) =>
                service.toLowerCase().includes(formValues.serviceName.toLowerCase().trim())
              );
            }
            return false;
          });
        }

        if (formValues.department && formValues.department.trim()) {
          filtered = filtered.filter(order => {
            const dept = order['Study Department'] || order.department || order.doctorDept || '';
            return dept.toString().toLowerCase().includes(formValues.department.toLowerCase().trim());
          });
        }

        if (formValues.studyDate) {
          filtered = filtered.filter(order => {
            const studyDate = order['Study Date'] || '';
            return studyDate.includes(formValues.studyDate);
          });
        }

        if (formValues.physician && formValues.physician.trim()) {
          filtered = filtered.filter(order => {
            const physician = order['Doctor Name'] || order.doctorName || '';
            return physician.toString().toLowerCase().includes(formValues.physician.toLowerCase().trim());
          });
        }

        this.filteredOrders = filtered;
        this.dupFilteredOrders = JSON.parse(JSON.stringify(filtered));
        this.totalRecords = filtered.length;
        this.loading = false;
      }
    }, 1000);
  }

  // Helper method to handle API responses
  private handleApiResponse(response: any, isSearch: boolean = false): void {
    if (!response) {
      this.loading = false;
      return;
    }

    // Check for error first
    if (response.error) {
      this.loading = false;
      return;
    }

    // Handle response
    if (response.Format_response) {
      const formattedOrders = response.Format_response;
      const originalData = response.original_api_response || response.Format_response;

      // Process orders
      const processedOrders = formattedOrders.map((order, index) => {
        // Extract study time from woDateTime if available
        let studyTime = order['Study Time'] || '';
        if (!studyTime && order['Study Date']) {
          // If study date contains time, extract it
          const fullDateTime = order['Study Date'];
          if (fullDateTime && fullDateTime.includes('T')) {
            const parts = fullDateTime.split('T');
            if (parts.length > 1) {
              studyTime = parts[1].substring(0, 8);
            }
          }
        }

        return {
          ...order,
          ServiceSubCategories: Array.isArray(order.ServiceSubCategories)
            ? order.ServiceSubCategories
            : (order.ServiceSubCategories ? [order.ServiceSubCategories] : []),
          ServiceSubCategoryIds: Array.isArray(order.ServiceSubCategoryIds)
            ? order.ServiceSubCategoryIds
            : (order.ServiceSubCategoryIds ? [order.ServiceSubCategoryIds] : []),
          'Study Time': studyTime,  // Ensure study time is set
          'Mobile': order.Mobile || order.mobile || '',  // Add mobile number
          'Modality': order['Modality'] || (Array.isArray(order.ServiceSubCategoryIds) ? order.ServiceSubCategoryIds.length : (order.ServiceSubCategoryIds ? 1 : 0)),
          'Files': order['Files'] || order.attachments?.length || 0,
          'departmentId': originalData[index]?.depId || '',
          'physicianId': originalData[index]?.phyId || '',
        };
      });

      // strict filtering: if searching by Service Name, remove orders that don't match
      // This prevents expanding an order and seeing "No service details available"
      const searchService = isSearch ? this.searchForm.get('serviceName').value?.trim().toLowerCase() : null;
      let finalOrders = processedOrders;

      if (searchService) {
        finalOrders = finalOrders.filter(order => {
          const services = order.ServiceSubCategories || [];
          // Check if any service matches matching the search term
          return services.some((s: string) => s.toLowerCase().includes(searchService));
        });
      }
        if(!!this.searchForm.get('department').value){
          finalOrders = finalOrders.filter(order => order.departmentId === this.searchForm.get('department').value);
        }
        if(!!this.searchForm.get('physician').value){
          finalOrders = finalOrders.filter(order => order.physicianId === this.searchForm.get('physician').value);
        }


      if (isSearch) {
        this.filteredOrders = this.formatOrdersForDisplay(finalOrders);
        this.dupFilteredOrders = JSON.parse(JSON.stringify(this.filteredOrders));
        this.originalApiData = originalData;
        this.totalRecords = response.pagination?.total && finalOrders.length === processedOrders.length
          ? response.pagination.total
          : finalOrders.length;
      } else {
        this.labOrders = finalOrders;
        this.originalApiData = originalData;
        this.filteredOrders = this.formatOrdersForDisplay(finalOrders);
        this.dupFilteredOrders = JSON.parse(JSON.stringify(this.filteredOrders));
        this.totalRecords = this.filteredOrders.length;
      }
    } else {
      // Fallback: if response is direct array
      if (Array.isArray(response)) {
        const processedOrders = response.map(order => ({
          ...order,
          'Patient ID': order.regNum || '',
          'Patient\'s Name': order.name || '',
          'Gender': order.gender || '',
          'Age': order.age || '',
          'Mobile': order.mobile || '',
          'Study Date': order.woDateTime || '',
          'Study Time': order.woDateTime ? this.formatTime(order.woDateTime) : '',
          'Study Department': order.doctorDept || '',
          'ServiceSubCategories': order.serviceSubCategories || [],
          'ServiceSubCategoryIds': order.serviceSubCategoryIds || [],
          '#S (Series)': order.serviceSubCategoryIds?.length || 0,
          '#I (Images)': 1,
          'departmentId': order?.depId || '',
          'physicianId': order?.phyId || '',
        }));

        let finalOrders = processedOrders;
        const searchService = isSearch ? this.searchForm.get('serviceName').value?.trim().toLowerCase() : null;
        if (searchService) {
          finalOrders = finalOrders.filter(order => {
            const services = order.ServiceSubCategories || [];
            return services.some((s: string) => s.toLowerCase().includes(searchService));
          });
        }
        if(!!this.searchForm.get('department').value){
          finalOrders = finalOrders.filter(order => order.departmentId === this.searchForm.get('department').value);
        }
        if(!!this.searchForm.get('physician').value){
          finalOrders = finalOrders.filter(order => order.physicianId === this.searchForm.get('physician').value);
        }

        this.filteredOrders = finalOrders;
        this.dupFilteredOrders = JSON.parse(JSON.stringify(this.filteredOrders));
        this.totalRecords = finalOrders.length;
      } else {
        if (isSearch) {
          this.filteredOrders = [];
          this.dupFilteredOrders = [];
          this.totalRecords = 0;
        } else {
          this.labOrders = [];
          this.filteredOrders = [];
          this.dupFilteredOrders = [];
          this.totalRecords = 0;
        }
      }
    }
    this.loading = false;
  }

  onModalityChange(event: any): void {
    if (event && event.length > 0) {
      this.selectedSubCategory = event[0].value;
    } else {
      this.selectedSubCategory = 'ALL';
    }
    this.loadDefaultOrders();
  }

  resetSearch(): void {
    this.searchForm.reset({
      patientID: '',
      patientName: '',
      mobileNumber: '',  // Add mobile number
      studyDate: '',
      physician: '',
      serviceName: '',
      department: '',
      limit: 10,
      offset: 0
    });
    this.selectedSubCategory = 'ALL';
    this.period = 'Today';
    this.loadDefaultOrders();



  }

  clearResults(): void {
    this.filteredOrders = [];
    this.dupFilteredOrders = [];
    this.totalRecords = 0;
    this.originalApiData = [];
    this.orderDetails.clear();
  }

  previousPage(): void {
    const currentOffset = this.searchForm.get('offset').value;
    const limit = this.searchForm.get('limit').value;
    const newOffset = Math.max(0, currentOffset - limit);
    this.searchForm.get('offset').setValue(newOffset);
    this.searchOrders();
  }

  nextPage(): void {
    const currentOffset = this.searchForm.get('offset').value;
    const limit = this.searchForm.get('limit').value;
    const newOffset = currentOffset + limit;
    this.searchForm.get('offset').setValue(newOffset);
    this.searchOrders();
  }

  toggleOrderDetails(order: any, index: number): void {
    const orderIndex = this.filteredOrders.indexOf(order);

    if (order.showDetails) {
      order.showDetails = false;
      this.orderDetails.delete(orderIndex);
    } else {
      // Show details and fetch if not already loaded
      order.showDetails = true;
      this.orderDetails.set(orderIndex, order);

      if (!order.serviceDetails) {
        this.loadOrderDetails(order, index);
      }
    }
  }

  loadOrderDetails(order: any, index: number): void {
    // First, try to get order details from API using woNo
    const orderId = order.woNo || order['woNo'] || order.workOrderId;

    if (orderId) {
      this.loading = true;

      // Call the Flask API to get detailed order information with attachments
      const url = `${this.pacsApiUrl}/${this.tenantId}/${this.branchId}/labworkordermst/${orderId}`;

      this.http.get(url, this.getFlaskHeaders())
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (response: any) => {


            if (response.error) {
              order.serviceDetails = this.fallbackToLocalDetails(order);
              return;
            }

            // Use the formatted response which has attachments
            const formattedResponse = response.formatted_response || response;
            const attachments = formattedResponse.attachments || [];

            // Process attachments to create service details
            order.serviceDetails = this.processAttachmentsToServiceDetails(attachments, order);
            order.attachments = attachments; // Store attachments for later use

            // Update counts for display in the main table
            // Calculate total active/visible files from the processed service details
            const activeFileCount = order.serviceDetails.reduce((sum, service) => sum + (service.attachments ? service.attachments.length : 0), 0);

            order['Modality'] = order.serviceDetails.length;
            order['Files'] = activeFileCount;

            this.loading = false;
          },
          (error) => {
            order.serviceDetails = this.fallbackToLocalDetails(order);
            this.loading = false;
          }
        );
    } else {
      // Fallback to local details if no order ID
      order.serviceDetails = this.fallbackToLocalDetails(order);
    }
  }

  private fallbackToLocalDetails(order: any): any[] {
    // Get service details from the order (your original method)
    const serviceSubCategories = order.serviceSubCategories || order.ServiceSubCategories || [];
    const serviceSubCategoryIds = order.serviceSubCategoryIds || order.ServiceSubCategoryIds || [];

    // Create service details array
    const serviceDetails = [];

    const maxLength = Math.max(serviceSubCategories.length, serviceSubCategoryIds.length);

    for (let i = 0; i < maxLength; i++) {
      serviceDetails.push({
        name: serviceSubCategories[i] || '-',
        id: serviceSubCategoryIds[i] || '-',
        department: order['Study Department'] || order.doctorDept || '-',
        attachments: [] // Empty array since we don't have attachments from API
      });
    }

    // Filter by Service Name search if active
    const searchService = this.searchForm.get('serviceName').value?.trim().toLowerCase();
    if (searchService) {
      return serviceDetails.filter(s => s.name.toLowerCase().includes(searchService));
    }

    return serviceDetails;
  }

  private processAttachmentsToServiceDetails(attachments: any[], order: any): any[] {
    // Group attachments by subcategory
    const serviceMap = new Map();

    attachments.forEach(attachment => {
      const subCategory = attachment.subCategory || {};
      const serviceId = subCategory.id;
      const serviceName = subCategory.name;

      if (serviceId) {
        if (!serviceMap.has(serviceId)) {
          serviceMap.set(serviceId, {
            id: serviceId,
            name: serviceName || '-',
            department: order['Study Department'] || order.doctorDept || '-',
            attachments: []
          });
        }

        // Add attachment to service
        const service = serviceMap.get(serviceId);
        service.attachments.push({
          blobUrl: attachment.blobUrl,
          fileName: attachment.fileName,
          fileLocation: attachment.fileLocation,
          workOrderDetId: attachment.workOrderDetId,
          subCategory: attachment.subCategory || { name: serviceName },
          isChecked: false // Initialize as unchecked
        });
      }
    });

    // Convert map to array
    let serviceDetails = Array.from(serviceMap.values());

    // Filter by Service Name search if active
    const searchService = this.searchForm.get('serviceName').value?.trim().toLowerCase();
    if (searchService) {
      serviceDetails = serviceDetails.filter(s => s.name.toLowerCase().includes(searchService));
    }

    // If no attachments found, fallback to original method
    if (serviceDetails.length === 0) {
      // Only fallback if we didn't filter everything out
      // If we filtered out services, we shouldn't fallback to showing everything
      // But if the map was empty to begin with, then fallback
      if (Array.from(serviceMap.values()).length === 0) {
        return this.fallbackToLocalDetails(order);
      }
    }

    return serviceDetails;
  }

  // Helper to open selected files (checked) or all if none checked
  openSelectedFiles(order: any, service: any): void {
    // 1. Get all checked attachments for this service
    let selectedAttachments = [];

    if (service && service.attachments) {
      selectedAttachments = service.attachments.filter(att => att.isChecked);
    }



    // 2. If nothing is checked, treat it as "Open All" (default behavior)
    if (selectedAttachments.length === 0) {
      this.openBlueLightViewer(order, service.id, service.name);
    } else {
      // 3. Otherwise, open ONLY the selected files
      // Pass the specific list of attachments to the viewer
      this.openBlueLightViewer(order, service.id, service.name, null, selectedAttachments);
    }
  }

  // Helper to count checked files for a service
  getCheckedCount(service: any): number {
    if (!service || !service.attachments) return 0;
    return service.attachments.filter(att => att.isChecked).length;
  }

  closeOrderDetails(order: any, index: number): void {
    const orderIndex = this.filteredOrders.indexOf(order);
    this.orderDetails.delete(orderIndex);
    if (this.filteredOrders[orderIndex]) {
      this.filteredOrders[orderIndex].showDetails = false;
    }
    this.dupFilteredOrders = JSON.parse(JSON.stringify(this.filteredOrders));
  }

  openOrderViewer(order: any): void {
    // If we already have attachments, just open the viewer
    if (order.attachments && order.attachments.length > 0) {
      this.openBlueLightViewer(order);
      return;
    }

    // Otherwise, fetch details first
    const orderId = order.woNo || order['woNo'] || order.workOrderId;
    if (orderId) {
      this.loading = true;
      const url = `${this.pacsApiUrl}/${this.tenantId}/${this.branchId}/labworkordermst/${orderId}`;

      this.http.get(url, this.getFlaskHeaders())
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (response: any) => {
            const formattedResponse = response.formatted_response || response;
            const attachments = formattedResponse.attachments || [];

            order.attachments = attachments;
            order.serviceDetails = this.processAttachmentsToServiceDetails(attachments, order);
            this.loading = false;

            if (attachments.length > 0) {
              this.openBlueLightViewer(order);
            } else {
              alert('No files found for this order.');
            }
          },
          (error) => {
            this.loading = false;
            // Fallback to local details and try opening
            order.serviceDetails = this.fallbackToLocalDetails(order);
            this.openBlueLightViewer(order);
          }
        );
    } else {
      // No order ID, just try to open with whatever we have
      this.openBlueLightViewer(order);
    }
  }

  openBlueLightViewer(order: any, serviceId?: string, serviceName?: string, initialBlobUrl?: string, specificAttachments?: any[]): void {
    // 1. Determine which attachments to pass to the viewer sidebar based on the user's action
    let attachmentsToPass = [];

    if (specificAttachments && specificAttachments.length > 0) {
      // MODE: Specific files selected (via checkboxes)
      attachmentsToPass = specificAttachments;
    } else if (initialBlobUrl) {
      // MODE: Specific file clicked - open only that file
      // Try to find the full attachment object from order.attachments to keep metadata
      const specificAtt = order.attachments?.find((a: any) => a.blobUrl === initialBlobUrl);
      if (specificAtt) {
        attachmentsToPass = [specificAtt];
      } else {
        // Fallback metadata if not found in order-level attachments
        attachmentsToPass = [{
          blobUrl: initialBlobUrl,
          fileName: 'Selected File',
          subCategory: { name: serviceName || 'File' }
        }];
      }
    } else if (serviceId || serviceName) {
      // MODE: "Open All Files" for a service - open only that service's files
      if (order.attachments && order.attachments.length > 0) {
        attachmentsToPass = order.attachments.filter((a: any) =>
          (serviceId && a.subCategory?.id === serviceId) ||
          (serviceName && a.subCategory?.name === serviceName)
        );
      }

      // Fallback if filtering didn't work or order attachments not available
      if (attachmentsToPass.length === 0) {
        const service = order.serviceDetails?.find((s: any) =>
          (serviceId && s.id === serviceId) || (serviceName && s.name === serviceName)
        );
        attachmentsToPass = service?.attachments || [];
      }
    } else {
      // MODE: "Load All Files for Order" - open all files for the entire order
      attachmentsToPass = order.attachments || [];
    }

    // 2. Determine the starting file (respective to what was clicked)
    let startFile = initialBlobUrl;
    if (!startFile && attachmentsToPass.length > 0) {
      startFile = attachmentsToPass[0].blobUrl;
    }

    // Build URL for BlueLight viewer
    const baseUrl = `${this.pacsApiUrl}/bluelight/html/start`;
    const params = new URLSearchParams();

    if (startFile) {
      params.append('initial_file', startFile);
    }

    params.append('tenant_id', this.tenantId);
    params.append('branch_id', this.branchId);
    params.append('embedded', 'true');
    params.append('auto_load', 'true');

    // Add patient information
    if (order['Patient ID'] || order.regNum) {
      params.append('patient_id', order['Patient ID'] || order.regNum);
    }
    if (order['Patient\'s Name'] || order.name) {
      params.append('patient_name', order['Patient\'s Name'] || order.name);
    }
    if (serviceName) {
      params.append('service_name', serviceName);
    }
    if (serviceId) {
      params.append('service_id', serviceId);
    }

    // If we have attachments, pass them as a JSON parameter
    if (attachmentsToPass.length > 0) {
      const formattedAttachments = attachmentsToPass.map((attachment: any) => ({
        blobUrl: attachment.blobUrl,
        fileName: attachment.fileName || 'file.dcm',
        fileType: this.getFileType(attachment.fileName || ''),
        subCategory: attachment.subCategory?.name || 'Unknown',
        workOrderDetId: attachment.workOrderDetId
      }));

      params.append('attachments', JSON.stringify(formattedAttachments));

      if (startFile) {
        params.append('initial_file', startFile);
      }
    } else if (startFile) {
      // Even if no attachment list, pass the initial file if we have it
      params.append('initial_file', startFile);
    }

    const viewerUrl = `${baseUrl}?${params.toString()}`;

    // Enhanced logging for debugging
    const mode = initialBlobUrl ? 'Single File' : (serviceId || serviceName) ? 'Service Files' : 'All Files';
    // Open in new tab
    window.open(viewerUrl, '_blank');
  }


  private getFileType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    if (ext === 'dcm' || ext === 'dicom' || ext === 'ima') {
      return 'dicom';
    } else if (['png', 'jpg', 'jpeg', 'gif', 'bmp'].includes(ext || '')) {
      return 'image';
    } else if (ext === 'pdf') {
      return 'pdf';
    } else {
      return 'dicom';
    }
  }


  formatDate(dateString: string): string {
    if (!dateString) return '';

    // Handle different date formats
    if (dateString.includes('T')) {
      return dateString.split('T')[0];
    }
    return dateString.substring(0, 10);
  }

  formatTime(timeString: string): string {
    if (!timeString) return '';


    // If it's already in HH:MM:SS format
    if (timeString.match(/^\d{2}:\d{2}:\d{2}$/)) {
      return timeString;
    }

    // If it's a date-time string with T separator
    if (timeString.includes('T')) {
      const parts = timeString.split('T');
      if (parts.length > 1) {
        const timePart = parts[1];
        // Extract HH:MM:SS
        return timePart.substring(0, 8);
      }
    }

    // If it's a full ISO string
    if (timeString.includes(':')) {
      const timeMatch = timeString.match(/(\d{2}:\d{2}:\d{2})/);
      if (timeMatch) {
        return timeMatch[1];
      }
    }

    return ''; // Return empty if no time found
  }

  // Helper method to format orders for display
  private formatOrdersForDisplay(orders: any[]): any[] {
    return orders.map((order, index) => {
      // Extract study time from woDateTime if available
      let studyTime = order['Study Time'] || '';
      if (!studyTime && order['Study Date']) {
        const fullDateTime = order['Study Date'];
        if (fullDateTime && fullDateTime.includes('T')) {
          const parts = fullDateTime.split('T');
          if (parts.length > 1) {
            studyTime = parts[1].substring(0, 8);
          }
        }
      }

      // Ensure all required fields exist for display
      return {
        ...order,
        showDetails: false,
        serviceDetails: null,
        // Ensure these fields exist for display
        'Patient ID': order['Patient ID'] || order.regNum || '',
        'Patient\'s Name': order['Patient\'s Name'] || order.name || '',
        'Gender': order.Gender || order.gender || '',
        'Age': order.Age || order.age || '',
        'Mobile': order.Mobile || order.mobile || '',  // Add mobile number
        'Study Date': order['Study Date'] || order.woDateTime || '',
        'Study Time': studyTime,
        'Study Department': order['Study Department'] || order.doctorDept || '',
        '#S (Series)': order['#S (Series)'] || (order.ServiceSubCategoryIds?.length || order.serviceSubCategoryIds?.length || 0),
        '#I (Images)': order['#I (Images)'] || '0',
        // Keep original fields for details
        serviceSubCategories: order.ServiceSubCategories || order.serviceSubCategories || [],
        serviceSubCategoryIds: order.ServiceSubCategoryIds || order.serviceSubCategoryIds || []
      };
    });
  }

  // Test Flask connection
  testFlaskConnection(): void {

    const testPayload = {
      pageName: "waiting",
      limit: 5,
      offset: 0
    };

    const url = `${this.pacsApiUrl}/${this.tenantId}/${this.branchId}/labworkordermst/searchOrders`;


    this.http.post(url, testPayload)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response: any) => {
        },
        (error) => {

        }
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  // load department data dropdown

  departmentList: Array<any> = [];
  loadDepartment(): void {
    if (this.departmentList.length == 0) {
      this.deptSrvc.list(this.tenantId + "/departments/getDepartmentMaster?branchId=" + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe(async (data: any) => {
        this.departmentList = data.details.filter(x => x.isActive == true && x.isClinical == "true")
      }, (error) => {
      }, () => {
      });
    }

  }
  physicianList: Array<any> = [];
  allowClear: any = true;
  multiple: boolean = false;
  filterphysician: Array<any> = [];
  getAllPhysicians() {

    this.phySrvc.list("physicians" + '/' + this.tenantId + '/' + this.branchId + `/getAssignedBranchPhysician?isActive=` + true + `&referralType=1&isClinical=true`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.physicianList = data.details;
      this.physicianList = [...this.physicianList]
      this.filterphysician = data.details;
    }, (error) => {
    }, () => {
    });
  }
  applyDepartmentFilter(event) {
    this.physicianList = [...this.filterphysician]
    if (event[0]?.value) {
      this.physicianList = this.physicianList.filter((doc) => doc?.departmentId == event[0]?.value);
      this.filteredOrders = this.dupFilteredOrders.filter((order) => order?.departmentId == event[0]?.value);
    } else {
      this.physicianList = this.physicianList;
      this.filteredOrders = this.dupFilteredOrders;
      this.searchForm?.get('physician')?.setValue(null);
    }
  }
  applyPhysicianFilter(event) {
    if (event[0]?.value) {
      this.filteredOrders = this.dupFilteredOrders.filter((order) => order?.physicianId == event[0]?.value);
    }
    else {
      this.filteredOrders = this.dupFilteredOrders;
    }
  }
  periodchange(event: any) {
    if (event?.[0].value == "Between") {
      this.betweenflag = true
    }
    else {
      this.betweenflag = false
    }
  }
}